module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-mobile@2x-2b0f74dc29bd79a5beca7af187c3b4af.jpg";